module.exports = __webpack_public_path__ + "static/media/Provisi Mandiri Pratama Logo (1).57d7e336.png";